<template>
  <li class="menu__item">
    <b-button
      :to="{ name: 'projectSubstations', params: { projectCode: project.code } }"
      active-class="btn--active"
      class="btn--menu"
      variant="link"
    >
      <Icon name="project" />
      {{ project.name || project.code }}
    </b-button>
    <ul v-if="isSuperadmin || isAdmin" class="menu__inner">
      <li class="menu__item">
        <b-button
          :to="{ name: 'editProject', params: { projectCode: project.code } }"
          variant="link"
          active-class="btn--active"
          class="btn--menu btn--icon-left"
        >
          <Icon name="settings" />
          Settings
        </b-button>
        <b-button
          :to="{ name: 'licenceAreas', params: { projectCode: project.code } }"
          variant="link"
          active-class="btn--active"
          class="btn--menu btn--icon-left"
        >
          <Icon name="licence-area" />
          Licence areas
        </b-button>
        <b-button
          :to="{ name: 'zonesList', params: { projectCode: project.code } }"
          variant="link"
          active-class="btn--active"
          class="btn--menu btn--icon-left"
        >
          <Icon name="licence-area" />
          Zones
        </b-button>
      </li>
      <li class="menu__item menu__item--add-substation text-right pb-4">
        <router-link
          v-if="isSuperadmin || isAdmin"
          :to="{ name: 'newSubstation', params: { projectCode: project.code } }"
          class="btn btn-rounded d-inline-block"
        >
          Add substation
          <Icon name="add" />
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'ProjectsMenuItem',
  props: {
    project: {
      type: Object,
      required: true
    },
    isSuperadmin: {
      type: Boolean,
      required: true
    },
    isAdmin: {
      type: Boolean,
      required: true
    }
  }
};
</script>
